import React from 'react'
import { AiOutlineArrowDown } from 'react-icons/ai';
function Card() {
  return (
   
    <div className='flex-col float-right'>

  
  <figure className="px-50 pt-500">
  <img src="https://firebasestorage.googleapis.com/v0/b/product-271bd.appspot.com/o/copy2.jpg?alt=media&token=793679c8-1553-466e-8500-b03a450e9a88"
   alt="Shoes" className="rounded-xl"width='1000' />
   <AiOutlineArrowDown color='white' />
  <img src = 'https://firebasestorage.googleapis.com/v0/b/product-271bd.appspot.com/o/copy-ai.png?alt=media&token=67b0e7cb-4855-48b8-a01a-7fab5948cbcb'
  />
  </figure>

</div>

  )
}

export default Card